import { XMarkIcon } from '@heroicons/react/24/solid';
import { useLocation } from '@remix-run/react';

const StagingPreview = () => {
  const { pathname } = useLocation();

  const handleNavigate = () => {
    // We intentially trigger a full page reload here to ensure this gets redirected back to the correct version of the site.
    window.location.href = `/preview/exit?page=${pathname}`;
  };

  return (
    <div className="flex justify-between gap-3 bg-black p-4 text-gray-500">
      <div className="flex justify-between gap-3">
        <div className="mt-1.5 h-2">
          <div className="h-2 w-2 animate-pulse rounded-full bg-green-500" />
        </div>
        <div className="flex flex-col gap-1">
          <h6 className="text-sm font-bold text-gray-100">Draft Preview</h6>
          <p className="text-xs font-medium text-gray-400">
            This is a private preview of your draft site—it is only visible to you. To return to your live site, simply
            "x" out of this preview.
          </p>
        </div>
      </div>
      <div className="mt-1 flex h-6 w-6 items-center justify-center">
        <button type="button" className="group rounded-md transition-all duration-100" onClick={handleNavigate}>
          <XMarkIcon className="h-6 w-6 text-gray-500 group-hover:text-gray-100" />
        </button>
      </div>
    </div>
  );
};

export default StagingPreview;
